$( ->
  $(document).on('click', 'a.open-new', (ev)->
    ev.preventDefault()
    modal_div = $('#' + $(this).attr('data-form'))
    form_div = modal_div.find('form')
    if (parseInt(form_div.attr('data-count')) > 0)
      modal_div.modal()
    else
      form_div.submit()
    return false
  )
)
